
import { supabase } from '@/integrations/supabase/client';

export const uploadImage = async (file: File, folder: string = 'blog-images'): Promise<string> => {
  try {
    // Create a unique file name
    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}_${Date.now()}.${fileExt}`;
    const filePath = `${folder}/${fileName}`;

    // Upload the file to Supabase storage
    const { error: uploadError, data } = await supabase.storage
      .from(folder) // Use the folder parameter as the bucket name
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
      });

    if (uploadError) throw uploadError;

    // Get the public URL
    const { data: { publicUrl } } = supabase.storage
      .from(folder) // Use the folder parameter as the bucket name
      .getPublicUrl(filePath);

    return publicUrl;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw new Error('Failed to upload image');
  }
};
